<template>
  <div>
    <input
      v-for="(quantity, key) in productFrames"
      :key="key"
      :name="productFrameName(key)"
      :value="quantity"
      type="hidden"
    >
  </div>
</template>

<script>
import { has } from 'lodash'

export default {
  name: 'PhotoSelectionFormInputs',
  computed: {
    productFrames () {
      const mixMatchSelections = this.$store.state.mixMatchSelections
      let result = {}

      mixMatchSelections.forEach(mms => {
        mms.frames.forEach(f => {
          if (f !== null) {
            const key = `${mms.catalogPackageOptionProductId}-${f.frameId}`
            if (has(result, key) === false) {
              result[key] = f.quantity
            } else {
              result[key] += f.quantity
            }
          }
        })
      })

      return result
    }
  },
  methods: {
    productFrameName (productFrame) {
      return `ProductFrameQty_${productFrame}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-mix/components/PhotoSelection/FormInputs.vue